export default "__VITE_ASSET__CZi6BDXE__"